import Prevention from '../../../components/customer/prevention/prevention/Prevention'

const CustomerPrevention = () => {
    return <Prevention />
}

export default CustomerPrevention
